<template>
    <div class="w-full">
        <vs-row>
                <vs-col class="px-2" vs-lg="6" vs-sm="12" vs-xs="12">
                    <Default :index="index" :label="$t('MODULE.typeFile')" option="File" property="default"></Default>
                </vs-col>
                <vs-col  vs-type="flex" vs-align="flex-end"  class="px-2" vs-lg="6" vs-sm="12" vs-xs="12">
                    <div class="w-full flex items-center">
                        <Number v-model="questionsByPage[index].properties.maxValue" :label="$t('MODULE.lengthFile')" :max="30" />
                        <span class="inline-block w-1/2 mt-4">
                            (MB)
                        </span>

                    </div>

                </vs-col>
        </vs-row>

        <h5 v-if="option !== 'all'"  class="my-3">{{$t('MODULE.extensionsFiles')}}</h5>
        <div v-if="option !== 'all'" class="itemsFile mt-3 pb-4">
            <div class="mb-2" v-for="(option, index) in options" :key="index">
                <vs-checkbox  v-model="extensions"  :vs-value="option">{{option}}</vs-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import  Number  from '../../components/Number.vue';
import Default from '../../componentsToQuestions/DefaultSelect.vue';
export default {
    props: ['index'],
    components: { Default, Number },
    data() {
        return {
            mounted: true,
            file: {
                all: ["all"],
                images: ["*.jpg", "*.jpeg", "*.bmp", "*.png", "*.gif"],
                documents: [ "*.txt", "*.csv", "*.doc", "*.docx", "*.xls", "*.xlsx", "*.ppt", "*.pptx", "*.pdf"],
                compressed: [ "*.zip", "*.rar"]
            }
        }
    },
    watch: {
        option(value) {
            if(value === 'all') this.questionsByPage[this.index].options = ['all'];
            else this.questionsByPage[this.index].options = [];
        }
    },
    computed: {
        /**
         * Obtiene y configura las extenciones aceptadas para la pegunta de tipo archivo.
         */
        extensions: {
            get() {
                return  this.questionsByPage[this.index].options;
            },
            set(value) {
                this.questionsByPage[this.index].options = value;
            }
        },
        ...mapState('resource',['questionsByPage']),
        /**
         * Obtiene la clase de archivo aceptada para el componente ó pregunta (imagenes, documentos, archivos compresos o todos los anteriores)
         */
        option() {
            return this.questionsByPage[this.index].properties.default;
        },
        /**
         * Obtiene un array con la lista de extensiones aceptadas por el componente.
         */
        options() {
            return this.file[this.option];
        },
    }
}
</script>

<style>
    .itemsFile {
        columns: 4;
        column-span: all;
    }
</style>
